const noop = () => {};

export function createLogger(prefix: string, enabled = false) {
  const tag = `[${prefix}]`;
  return {
    log: enabled ? console.log.bind(console, tag) : noop,
    warn: enabled ? console.warn.bind(console, tag) : noop,
    error: enabled ? console.error.bind(console, tag) : noop,
  };
}
